import * as React from 'react';
import Select from 'react-select';
import { Col, Collapse, FormFeedback, Input, Label, Row } from 'reactstrap';
import dateHelper from '../../utils/dateHelper';



const FiscalYearEditor = (props: any) => {

    let presetOptions: Array<{ value: string; label: string; }> = [
        { value: "0", label: "Select A Fiscal Year" },
        { value: "1", label: "September 30" },
        { value: "2", label: "December 31" },
        { value: "3", label: "March 31" },
        { value: "4", label: "June 30" },
        { value: "5", label: "Other" },
    ];

    let monthOptions: Array<{ value: string; label: string; }> = [
        { value: "0", label: "Select A Month" },
        { value: "1", label: "January" },
        { value: "2", label: "February" },
        { value: "3", label: "March" },
        { value: "4", label: "April" },
        { value: "5", label: "May" },
        { value: "6", label: "June" },
        { value: "7", label: "July" },
        { value: "8", label: "August" },
        { value: "9", label: "September" },
        { value: "10", label: "October" },
        { value: "11", label: "November" },
        { value: "12", label: "December" },
    ];

    //defaults
    const customFiscalMonthDayOption = { value: "5", label: "Other" };
    const defaultFiscalMonthOption = { value: "0", label: "Select A Month" };
    const defaultFiscalDayOption = { value: "0", label: "Select A Day" };
    const defaultPreset = { value: "0", label: "Select A Fiscal Year" };


    //options
    const [fiscalMonthOptions, setFiscalMonthOptions]
        = React.useState<Array<{ value: string; label: string; }>>([]);

    const [fiscalDayOptions, setFiscalDayOptions]
        = React.useState<Array<{ value: string; label: string; }>>([]);

    //local hooks
    const [selectedFiscal, setSelectedFiscal]
        = React.useState<{ value: string; label: string }>(defaultPreset);

    const [selectedFiscalMonth, setSelectedFiscalMonth]
        = React.useState<{ value: string; label: string }>
            (defaultFiscalMonthOption);

    const [selectedFiscalDay, setSelectedFiscalDay]
        = React.useState<{ value: string; label: string }>(defaultFiscalDayOption);

    const [fiscalMonthYearCollapseIn, setFiscalMonthYearCollapseIn] = React.useState<boolean>(false);
    const [fiscalDayCollapseIn, setFiscalDayCollapseIn] = React.useState<boolean>(false);

    //functions
    const handleFiscalChange = (selectItem: { value: string; label: string }) => {
        if (selectItem.value == customFiscalMonthDayOption.value) {
            props.setFiscalMonth(0);
            props.setFiscalDay(0);
            setSelectedFiscalMonth(defaultFiscalMonthOption);
            setFiscalMonthYearCollapseIn(true);
            setFiscalDayCollapseIn(false);
        } else {
            switch (selectItem.value) {
                case "0":
                    props.setFiscalMonth(0);
                    props.setFiscalDay(0);
                    break;
                case "1":
                    props.setFiscalMonth(9);
                    props.setFiscalDay(30);
                    break;
                case "2":
                    props.setFiscalMonth(12);
                    props.setFiscalDay(31);
                    break;
                case "3":
                    props.setFiscalMonth(3);
                    props.setFiscalDay(31);
                    break;
                case "4":
                    props.setFiscalMonth(6);
                    props.setFiscalDay(30);
                    break;
            }
            setFiscalMonthYearCollapseIn(false);
            setFiscalDayCollapseIn(false);
        }
        setSelectedFiscal(selectItem);
    }

    const handleFiscalMonthChange = (selectItem: { value: string; label: string }) => {

        if (selectItem.value == defaultFiscalMonthOption.value) {
            props.setFiscalMonth(0);
            props.setFiscalDay(0);
            setFiscalDayCollapseIn(false);
        }
        else {
            props.setFiscalMonth(Number(selectItem.value));
            props.setFiscalDay(0);
            initializeFiscalDayOptions(dateHelper.daysInMonth(selectItem.label));
            setFiscalDayCollapseIn(true);
        }
        setSelectedFiscalMonth(selectItem);
        setSelectedFiscalDay(defaultFiscalDayOption);
    }

    const handleFiscalDayChange = (selectItem: { value: string; label: string }) => {
        props.setFiscalDay(Number(selectItem.value));
        setSelectedFiscalDay(selectItem);
    }

    const initializeFiscalDayOptions = (days: number) => {
        let dayOptions: Array<{ value: string; label: string; }> = [
        ];
        dayOptions.push(defaultFiscalDayOption);
        for (var i = 0; i < days; i++) {
            let valueLabel: string = (i + 1).toString();
            dayOptions.push({ label: valueLabel, value: valueLabel });
        }
        setFiscalDayOptions(dayOptions);
    }

    const IsFiscalYearIsValid = (): boolean => {
        var result = false;

        if (selectedFiscal.value != "0" &&
            selectedFiscal.value != "5") {
            result = true;
        }
        else if (selectedFiscal.value == "5") {
            if (selectedFiscalMonth.value != "0" && selectedFiscalDay.value != "0") {
                result = true;
            }
        }

        return result;
    }

    React.useEffect(() => {
        if (props.fiscalMonth && props.fiscalDay) {
            var selectedOption;
            if (props.fiscalMonth == 9 && props.fiscalDay == 30) {
                selectedOption = presetOptions.find(presetOption => presetOption.value == "1");
                if (selectedOption && selectedFiscal.value != selectedOption.value) {
                    handleFiscalChange(selectedOption);
                    setFiscalMonthYearCollapseIn(false);
                    setFiscalDayCollapseIn(false);
                }

            }
            else if (props.fiscalMonth == 12 && props.fiscalDay == 31) {
                selectedOption = presetOptions.find(presetOption => presetOption.value == "2");
                if (selectedOption && selectedFiscal.value != selectedOption.value) {
                    handleFiscalChange(selectedOption);
                    setFiscalMonthYearCollapseIn(false);
                    setFiscalDayCollapseIn(false);
                }
            }
            else if (props.fiscalMonth == 3 && props.fiscalDay == 31) {
                selectedOption = presetOptions.find(presetOption => presetOption.value == "3");
                if (selectedOption && selectedFiscal.value != selectedOption.value) {
                    handleFiscalChange(selectedOption);
                    setFiscalMonthYearCollapseIn(false);
                    setFiscalDayCollapseIn(false);
                }
            }
            else if (props.fiscalMonth == 6 && props.fiscalDay == 30) {
                selectedOption = presetOptions.find(presetOption => presetOption.value == "4");
                if (selectedOption && selectedFiscal.value != selectedOption.value) {
                    handleFiscalChange(selectedOption);
                    setFiscalMonthYearCollapseIn(false);
                    setFiscalDayCollapseIn(false);
                }
            }
            else if (props.fiscalMonth != 0 && props.fiscalDay == 0) {
                if (selectedFiscal.value != customFiscalMonthDayOption.value) {
                    setSelectedFiscal(customFiscalMonthDayOption);
                    setFiscalMonthYearCollapseIn(true);
                    setFiscalDayCollapseIn(false);
                }
                if (String(props.fiscalMonth) != selectedFiscalMonth.value) {
                    setSelectedFiscal(customFiscalMonthDayOption);
                    selectedOption = monthOptions.find(monthOpt => monthOpt.value == String(props.fiscalMonth));
                    if (selectedOption) {
                        handleFiscalMonthChange(selectedOption);

                    }
                }
            } else if (props.fiscalMonth != 0 && props.fiscalDay != 0) {
                if (selectedFiscal.value != customFiscalMonthDayOption.value) {
                    setSelectedFiscal(customFiscalMonthDayOption);
                    setFiscalMonthYearCollapseIn(true);
                    setFiscalDayCollapseIn(true);
                }
                if (String(props.fiscalMonth) != selectedFiscalMonth.value) {
                    setSelectedFiscal(customFiscalMonthDayOption);
                    selectedOption = monthOptions.find(monthOpt => monthOpt.value == String(props.fiscalMonth));
                    if (selectedOption) {
                        setSelectedFiscalMonth(selectedOption);
                        setSelectedFiscalDay(defaultFiscalDayOption);
                        setFiscalMonthYearCollapseIn(true);
                        setFiscalDayCollapseIn(true);
                    }
                }
                if (String(props.fiscalDay) != selectedFiscalDay.value) {
                    
                    initializeFiscalDayOptions(dateHelper.daysInMonth(selectedFiscalMonth.label));
                    selectedOption = fiscalDayOptions.find(dayOpt => dayOpt.value == String(props.fiscalDay));
                    if (selectedOption) {
                        handleFiscalDayChange(selectedOption);
                        setFiscalMonthYearCollapseIn(true);
                        setFiscalDayCollapseIn(true);
                    }
                }
            }
        }
    }, [props])

    return (
        <React.Fragment>
            <Row>
                <Col>
                    <Label>Fiscal Year:</Label>
                </Col>
                <Col md="9">
                    <Select
                        value={selectedFiscal}
                        onChange={handleFiscalChange}
                        options={presetOptions}
                        isDisabled={!props.readyForUse}
                    />

                    <Input type="hidden" value={""}
                        onChange={(e) => { }}
                        valid={IsFiscalYearIsValid()}
                        invalid={!IsFiscalYearIsValid() && props.readyForUse}
                        disabled={true}
                    />
                    <FormFeedback>Fiscal year month and day are required.</FormFeedback>
                </Col>
            </Row>

            <Collapse isOpen={fiscalMonthYearCollapseIn}>
                <Row>
                    <Col>
                        <Label>Fiscal Month:</Label>
                    </Col>
                    <Col md="9">
                        <Select
                            value={selectedFiscalMonth}
                            onChange={handleFiscalMonthChange}
                            options={monthOptions}
                        />
                    </Col>
                </Row>
            </Collapse>

            <Collapse isOpen={fiscalDayCollapseIn}>
                <Row>
                    <Col>
                        <Label>Fiscal Day:</Label>
                    </Col>
                    <Col md="9">
                        <Select
                            value={selectedFiscalDay}
                            onChange={handleFiscalDayChange}
                            options={fiscalDayOptions}
                        />
                    </Col>
                </Row>
            </Collapse>

        </React.Fragment>
    );
}

export default FiscalYearEditor;